import { render } from "./TheHeader.vue?vue&type=template&id=55c5011e"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=55c5011e&lang=css"
script.render = render

export default script